import { combineReducers } from "redux"
import { activation } from './rootAccessActivationReducer'

const activationReducers = combineReducers({
    activation,
})

export default activationReducers